import { UserOutlined } from '@ant-design/icons';
import React from 'react';

export default [
  {
    icon: <UserOutlined />,
    path: '/personal-account',
    // TODO: Use i18n
    text: 'Personal Account',
  },
] as const;
